var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "flex flex-wrap" }, [
      _c(
        "div",
        { staticClass: "w-full md:w-3/4 md:pr-20" },
        [
          _c("h1", { staticClass: "mb-5 font-sans text-n-gray-dark" }, [
            _vm._v("My Resources"),
          ]),
          _vm._v(" "),
          _c(
            "router-link",
            { staticClass: "button mb-12", attrs: { to: "/resources/create" } },
            [_vm._v("Create New Resource")]
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-wrap -mx-6 pt-12" },
            _vm._l(_vm.resources, function (resource) {
              return _c("user-dashboard-item", {
                key: resource.id,
                attrs: { resource: resource },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "w-full md:w-1/4 md:pt-40" }, [
        _c(
          "div",
          { staticClass: "sidebar-block border-t-5 border-black pt-3" },
          [
            _c("public-profile-link"),
            _vm._v(" "),
            _c(
              "h2",
              { staticClass: "text-lg mb-5 font-sans text-n-gray-dark" },
              [_vm._v("Help with My Resources")]
            ),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("support"),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mb-8" }, [
      _c("p", { staticClass: "mb-5" }, [
        _vm._v(
          "In this moment, we need to offer what we can. Add your existing services, products, art, workshops and educational offerings--along with the inspiring stories behind your work--for discovery on "
        ),
        _c(
          "a",
          {
            attrs: {
              href: "http://www.letsreimagine.org/resources",
              target: "_blank",
            },
          },
          [_vm._v("Reimagine Community Resources")]
        ),
        _vm._v(
          " and for inclusion on your Reimagine profile page. You can also create new text-based resources like articles or poems directly through this Portal. See the "
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://help.letsreimagine.org/hc/en-us/articles/360041714752-What-is-Reimagine-Community-Resources-",
              target: "_blank",
            },
          },
          [_vm._v("criteria for resource submissions")]
        ),
        _vm._v(" in our Help Center."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "list-reset mb-10 text-base" }, [
      _c("li", { staticClass: "mb-2" }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://help.letsreimagine.org/hc/en-us/sections/360008462652-Submitting-your-community-resources",
            },
          },
          [_vm._v("Creating & Submitting Resources")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }